<template>
  <div class="index-content">
    <div>
      <img class="top-big-logo" src="../../images/ITWE/01.jpg" alt="">
      <p>烟台国际葡萄酒博览会从2007年开始，已成功举办11届。作为一个国际化的葡萄酒交流平台，烟台葡萄酒博览会得到了国内外葡萄酒行业的持续关注。<span class="red">2019年6月28-30日，在烟台国际葡萄•葡萄酒城，</span>第12届烟台国际葡萄酒博览会期待再次与您相聚!</p>
      <p style="margin-top: 20px; font-size: 16px; font-weight: 900; line-height: 1.6;">为迎接本次盛会，酒咔嚓与烟台酒博会合作推出<span class="red" style="vertical-align: bottom;">酒咔嚓特别参观团</span>，成功报名将获得以下尊享福利：</p>
      <div style="text-align: left;" class="kacha-advantages">
        <div class="item" v-for="(advantage, i) in kachaAdvantages">
          <p>
            <span class="red">特别尊享{{ circleNum[i] }} </span>
            <span class="black">
              <span class="black">【</span>
              {{ advantage.title }}
              <span class="black">】</span>
            </span>
          </p>
          <p class="desc">——{{ advantage.desc }}</p>
        </div>

        <div class="remark" style="font-size: 15px; margin-top: 20px;">
          注：酒咔嚓特别参观团<span class="bold red">名额有限</span>，提早报名将获得优先安排！报名成功者将由我们的客服人员联系确认。
        </div>

        <!--<div class="red" style="font-size: 16px; margin-top: 20px; text-align: center;">立即点击下方按钮报名吧！</div>-->
      </div>
    </div>

    <div style="text-align: center" class="bottomFixBtns maxScreenWidth">
      <a :href="itweIntroduceUrl" target="_blank" class="btn1" @click="goToIntroducePage(itweIntroduceUrl)">展会介绍</a>
      <a href="javascript:" class="signUp-btn" @click="goToSignUpPage">立即报名</a>
    </div>

  </div>
</template>

<script>
import utils from '../../utils'
import userBehaviorLogs from '../../api/userBehaviorLogs'
import getBrowserType from '../../utils/getBrowserType'
import getPlatform from '../../utils/getPlatform'

export default {
  name: 'index',
  data () {
    return {
      itweIntroduceUrl: 'https://static.9kacha.com/iims/html/news/b1c6133d-c3ab-d9b2-d2d7-410e72805c71.html',
      browserType: getBrowserType(),
      platform: getPlatform(),
      kachaAdvantages: [
        { title: '免费提供住宿', desc: '为参观企业在27日提供晚宴，并免费提供3天住宿（6月27日-29日）， 方便观展。' },
        { title: '产区及酒庄旅游活动', desc: '酒博会期间，逛酒展、品美酒、赏美景，悟仙道，开启中国葡萄酒的寻根、发现之旅！' },
        { title: '车站/机场免费大巴接送', desc: '届时安排免费大巴到烟台火车站/机场接送参展商。' },
        { title: '主题论坛及葡萄酒品鉴活动', desc: '优先报名展会期间主题论坛和品酒活动，与众多知名行业专家、组织及协会代表互动交流。' }
      ],
      circleNum: ['①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩', '⑪', '⑫', '⑬', '⑭', '⑮', '⑯', '⑰', '⑱', '⑲', '⑳']
    }
  },
  computed: {
    source () {
      return this.$route.params.source || utils.getQueryString('source') || '酒咔嚓'
    }
  },
  methods: {

    goToIntroducePage (accessUrl) {
      userBehaviorLogs({
        op_event: '去展会介绍页面',
        source: this.source,
        access_url: accessUrl
      })
    },

    goToSignUpPage () {
      this.$router.push({
        name: 'signUp',
        params: {
          source: this.source
        }
      })
    }
  },
  mounted () {

  }
}
</script>

<style scoped lang="less">
  @import "../../less/variable";
  @mainRed: #C13B4D;
  .red {
    color: #C13B4D;
    font-weight: 900;
  }
  .bold {
    vertical-align: bottom;
    font-weight: 900;
  }

  .center {
    text-align: center;
  }
  .index-content {
    min-height: 100vh;
    width: 100%;
    background-color: #fff;
    color: #333;
    line-height: 2;
    box-sizing: border-box;
    font-size: 14px;
    .padding(8, 12);
    padding-bottom: 90px;
    .top-title {
      font-size: 20px;
      padding-bottom: 5px;
      font-weight: 900;
      border-bottom: 1px solid #eee;
      line-height: 1.6;
    }
    .top-big-logo {
      margin-top: 10px;
    }
    .kacha-big {
      margin-top: 5px;
    }
    .top-big-logo+p {
      margin-top: 10px;
    }
    .country-and-organization {
      img {
        margin-top: 20px;
      }
    }
    img {
      width: 100%;
    }

    .title1 {
      display: inline-block;
      padding: 5px 10px;
      background-color: #f5d542;
      line-height: 1.4;
      margin-top: 25px;
    }

    .exhibitors-link {
      margin-top: 20px;
      a{
        &:link,
        &:visited,
        &:active,
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .kacha-advantages {
      line-height: 1.8;
      margin-top: 30px;
      .item {
        color: #7F7F7F;
        margin-top: 15px;
        span {
          vertical-align: bottom;
        }
        .red, .black {
          font-size: 15px;
        }
        .red {
          color: #C13B4D;
          font-weight: 900;
        }
        .black {
          color: #3f3f3f;
          font-weight: 900;
        }
        .desc {

        }
      }
    }

    @keyframes signUpBgChange
    {
      0% {background: #C13B4D;}
      100% {background: #E06B7B;}
    }
    @keyframes hankAnimation
    {
      0% {transform: translate(0, 0)}
      100% {transform: translate(-10px, -5px)}
    }
    .bottomFixBtns {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      padding: 10px;
      height: 70px;
      line-height: 50px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: #fff;
      box-sizing: border-box;
      box-shadow: 0px -8px 10px 0px rgba(110, 110, 110, 0.1);
      font-size: 16px;
      .btn1 {
        .w(80);
        height: 100%;
        background-color: #3a95ff;
        color: #fff;
      }

      .signUp-btn {
        height: 100%;
        flex: 1;
        margin-left: 10px;
        text-align: center;
        display: inline-block;
        letter-spacing: 4px;
        color: #fff;
        background: #C13B4D;
        position: relative;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/index/content.vue